import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { Box, Card, CardContent, Typography, Alert } from "@mui/material";

import { Link } from "components/html/Link";
import { FormErrors } from "components/utility/FormErrors";
import { HoverHelp } from "components/utility/HoverHelp";
import { VSpace } from "components/utility/VSpace";

import { i18n } from "services/i18nService";

import { useErrors } from "hooks/useErrors";

import { INTUIT_AUTH_URL, INTUIT_AUTH_REDIRECT_URL } from "appConstants";
import { v4 as uuidv4 } from "uuid";

export function QuickBooksConnect() {
  const { state } = useLocation();
  const { errors, setErrors } = useErrors();

  useEffect(() => {
    if (state?.authError) {
      setErrors({ messages: [state?.authError] });
    }
  }, [state?.authError, setErrors]);

  function startUpsAuthFlow() {
    const state = uuidv4();
    localStorage.setItem("qboState", state);
    const clientId = process.env.REACT_APP_INTUIT_CLIENT_ID;
    window.location.href = `${INTUIT_AUTH_URL}?client_id=${clientId}&redirect_uri=${INTUIT_AUTH_REDIRECT_URL}&response_type=code&state=${state}&scope=com.intuit.quickbooks.accounting`;
  }

  return (
    <>
      <Box sx={{ display: "grid", minWidth: "1070px" }} m={2} mb={0}>
        <Box mb={1}>
          <Typography variant="h2">{i18n("quickBooks.header")}</Typography>
        </Box>
        <Card variant="outlined" sx={{ maxWidth: "750px" }}>
          <CardContent>
            <FormErrors errors={errors} setErrors={setErrors} />
            <Typography sx={{ mb: 2 }}>
              {i18n("quickBooks.description")}
            </Typography>
            <Alert sx={{ mb: 2 }} severity="error">
              {i18n("quickBooks.alert")}{" "}
              <Link
                component="a"
                rel="noreferrer"
                href="mailto:support@sosinventory.com"
                target="_blank"
              >
                support@sosinventory.com
              </Link>
            </Alert>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <input
                type="image"
                onClick={startUpsAuthFlow}
                src="/images/C2QB_green_btn_med_default.png"
                alt="Connect to QuickBooks"
                align="left"
                style={{ borderWidth: "0px" }}
              />
              <HoverHelp
                title={i18n("quickBooks.connect.hoverHelp")}
                sx={{ marginLeft: 0.5 }}
              />
            </Box>
            <VSpace space={2} />
          </CardContent>
        </Card>
        <VSpace space={4} />
      </Box>
    </>
  );
}
